import actions from './actions.js'
import getters from './getters.js'
export default {
	namespaced: true,
	actions,
	getters
}